import React, { useState } from "react";
import {
  Tabs,
  Tag
} from "antd";
import { Navbar } from "../Navigation/Navbar";
import "../../Styles/styles-Compare.css";
import "../../Styles/styles-PostData.css";
import { useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";

import { LoadingComponent } from "../Common/LoadingComponent";
import { Comparison1V1 } from "./Comparison1V1"
import { ComparisonMultiRange } from "./ComparisonMultiRange"
import { DayCompare } from "./DayCompare"
import { HelpButton } from "../Common/HelpButton";

export const Compare = () => {
  const {
    loading,
  } = useSelector(({ compare }) => compare);

  const { user } = useAuth0();

  const [activeTab, setActiveTab] = useState("1");
  const compare1v1 = <div>1v1</div>;
  const betaTagMultiRange = <div className="beta-button">Date Range Compare</div>;

  const items = [{
    label: "Day Compare",
    key: "1",
    children: <DayCompare activeTab={activeTab}></DayCompare>
  },
  {
    label: compare1v1,
    key: "2",
    children:  <Comparison1V1 activeTab={activeTab}/>
  },
  {
    label: betaTagMultiRange,
    key: "3",
    children:  <ComparisonMultiRange activeTab={activeTab}/>
  }]

  return (
    <>
      <Navbar />
      <HelpButton page="Compare" />
      <div className="search-divider"></div>
      <LoadingComponent loading={loading}>
        <Tabs
          defaultActiveKey="1"
          type="card"
          onChange={setActiveTab}
          centered
          items={items}
        >
        </Tabs>
      </LoadingComponent>
    </>
  );
};
